
import { WFormConfigItem } from './WFormConfigItem';

export class WFormConfig {

    items: Array<WFormConfigItem> = new Array;
    name?: string;

    constructor() {
        this.addItem = this.addItem.bind(this);
    }
    addItem(item: WFormConfigItem) {
        this.items.push(item);
    }
    addData(data: Array<WFormConfigItem>) {
        // this.items = data;
        this.items = [...data];  // Damit wir nicht die Original-Formdaten manipulieren
    }
    getItem(key: string) {
        return this.items.find((item: WFormConfigItem) => item.key === key);
    }
    removeItem(key: string) {
        if (this.items && this.items.length > 0) {
            const idx = this.items.findIndex((item: WFormConfigItem) => item.key === key);
            if (idx && idx !== -1) {
                this.items.splice(idx, 1);
            }
        }
    }
}
